<template>
	<div class="no-auth">
		<div v-if="isAuth">
			<slot></slot>
		</div>
		<el-card v-else>
			<div class="content">
				<div class="left">
					<img src="https://cdn.dkycn.cn/melyshop/image/20210831-7138a2bc-e050-4992-a45e-b6c482e0bd31.png">
					<div class="info">
						<div class="tit">进群欢迎语</div>
						<div class="tip">在这里创建进群欢迎语素材，配置完成后，企业微信客户群的群主可在群聊中选择其中一个欢迎语使用，客户进入群聊后，将收到欢迎语。</div>
					</div>
				</div>
				<div class="right">
					<el-button type="primary" @click="handleUse">授权安装企店助手</el-button>
				</div>
			</div>
			<div style="margin-top:25px">
				<div class="desc-title">1/功能说明</div>
				<img style="display: block;width:100%;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210914-bef24be3-abef-4d4c-8c6d-a73ca6ba49f9.png"></img>
				<div class="desc-title">2/欢迎语配置</div>
				<img style="display: block;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210831-cf20a7ff-fc30-4c73-8800-6161e9db9cd7.png"></img>
				<div class="desc-title">2/群主使用欢迎语</div>
				<img style="display: block;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210831-c25accb7-521f-42a1-b5f7-90857becaaaf.png"></img>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		qyweixinsuiteauthinfo
	} from "@/api/sv1.0.0";
	import config from "@/config/index";

	export default {
		components: {},
		data() {
			return {
				isAuth: true,
				goUrls: config.GO_URL,
			};
		},
		beforeMount() {
			this.getData();
		},
		methods: {
			async getData(callback) {
				try {
					const res = await qyweixinsuiteauthinfo();
					this.isAuth = res.Result.IsFinishQyWeixinSuiteStp;
				} catch (e) {
				}
			},
			handleUse() {
				// let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
				// let url = this.goUrls + headsUrls + '/saleChannel/qyWechat'
				// window.open(url)
				this.$router.push({
					path: '/saleChannel/qyWechat'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.desc-title{
		font-weight: bold;
		margin-top: 30px;
		font-size: 16px;
		margin-bottom: 10px;
	}
	.desc-content{
		font-size: 14px;
		color: #606266;
		line-height: 20px;
		
		>div{
			margin-bottom: 5px;
		}
	}
	.content {
		display: flex;
		align-items: center;
		overflow: hidden;
		padding: 15px;
		background-color: #f8f8f9;
		
		
	
		.left {
			flex: 1 1 auto;
			overflow: hidden;
			margin-right: 20px;
			display: flex;
	
			img {
				flex: 0 0 auto;
				width: 46px;
				height: 46px;
			}
	
			.info {
				flex: 1 1 auto;
				overflow: hidden;
				margin-left: 10px;
				padding-top: 2px;
	
				.tit {
					font-size: 14px;
					font-weight: bold;
				}
	
				.tip {
					font-size: 12px;
					color: #999;
					margin-top: 10px;
				}
			}
		}
	
		.right {
			flex: 0 0 auto;
		}
	}
</style>
